import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useScrollableDrafts } from './common/scrollable-wires-hooks';
import Tail from './common/wires-list-tail';
import commonProps from './common/common-props';
import useGetPaginatedDrafts from '../../../services/wires/contributor-wires-service';
import Wire from './common/wire';

export default function MyDrafts() {
  const common = commonProps();
  const {
    wires, infiniteRef, expandList, showExpand,
  } = useScrollableDrafts({ useGetWires: useGetPaginatedDrafts });

  return (
    <ThemeProvider theme={common}>
      <>
        <article>
          {wires.map(wire => <Wire key={`my-draft-${wire.id}`} wire={wire} />)}
          <div ref={infiniteRef} />
          {!!showExpand && (
            <Tail><button type="button" onClick={expandList}>see all drafts</button></Tail>
          )}
        </article>
      </>
    </ThemeProvider>
  );
}
